import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  imports:[NgIf,],
  standalone: true,
  template: `
    <div *ngIf="loader.isLoading()" class="loader-overlay">
      <div class="loader"></div>
    </div>
  `,
  styles: [`
    .loader-overlay {
      position: fixed;
      top: 0; left: 0; width: 100%; height: 100%;
      display: flex; justify-content: center; align-items: center;
      background: rgba(0, 0, 0, 0.5);
      z-index: 9999;
    }
    .loader {
      width: 50px; height: 50px;
      border: 5px solid white;
      border-top: 5px solid transparent;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    @keyframes spin { 
      100% { transform: rotate(360deg); } 
    }
  `]
})
export class LoaderComponent {
  loader = inject(LoaderService);
}
